"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Condition = {
    type: "structure",
    required: [],
    members: {
        HttpErrorCodeReturnedEquals: {
            shape: {
                type: "string"
            }
        },
        KeyPrefixEquals: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Condition.js.map